import React from 'react';
import SidePanelPersonRow from './SidePanelPersonRow';

export default function ChatSidePanelPeopleList({
  people = [],
  onSelect,
  resolveSelectPayload,
  resolveRowKey,
  resolveRowProps,
  listClassName = 'side-list side-list--people',
}) {
  const safePeople = Array.isArray(people) ? people : [];

  return (
    <ul className={listClassName}>
      {safePeople.map((person, index) => {
        const rowKey =
          (typeof resolveRowKey === 'function' ? resolveRowKey(person, index) : null)
          || person?.key
          || `person-${index}`;
        const rowProps =
          typeof resolveRowProps === 'function' ? resolveRowProps(person, index) || {} : {};

        return (
          <SidePanelPersonRow
            key={rowKey}
            person={person}
            onSelect={onSelect}
            resolveSelectPayload={resolveSelectPayload}
            {...rowProps}
          />
        );
      })}
    </ul>
  );
}
